import type { EditorSDK } from '@wix/platform-editor-sdk';
import type { ComponentRef } from '@wix/yoshi-flow-editor';

export const findFirstChild = async (
  editorSDK: EditorSDK,
  componentRef: ComponentRef,
) => {
  const children = await editorSDK.components.getChildren('token', {
    componentRef,
  });

  return children[0];
};
